import { render, staticRenderFns } from "./AllocationOfFteTable.vue?vue&type=template&id=0829f941&scoped=true"
import script from "./AllocationOfFteTable.vue?vue&type=script&lang=js"
export * from "./AllocationOfFteTable.vue?vue&type=script&lang=js"
import style0 from "./AllocationOfFteTable.vue?vue&type=style&index=0&id=0829f941&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0829f941",
  null
  
)

export default component.exports